import { render, staticRenderFns } from "./permissions-editor.vue?vue&type=template&id=4ccc5000&scoped=true&"
import script from "./permissions-editor.vue?vue&type=script&lang=js&"
export * from "./permissions-editor.vue?vue&type=script&lang=js&"
import style0 from "./permissions-editor.vue?vue&type=style&index=0&id=4ccc5000&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccc5000",
  null
  
)

export default component.exports